module.exports = __webpack_public_path__ + "img/ai-task-hire.f86ba9d2.svg";